import { useEffect, useState } from "react";
import { Route, Routes, Link } from "react-router-dom";
import "./Assets/css/Style.css";
// import "./Assets/css/NewLanding.css";
import "./Assets/css/Landing.css";
import Landing from "./Screens/Landing";
import Plans from "./Screens/Plans";
import Opportunities from "./Screens/Opportunities";
import Dashboard from "./Screens/Dashboard";
import TicketManagement from "./Screens/TicketManagement";
import TransactionHistory from "./Screens/TransactionHistory";
import SupportTicket from "./Screens/SupportTicket";
import TermsOfServices from "./Screens/TermsOfServices";
import PrivacyPolicy from "./Screens/PrivacyPolicy";

import "./App.css";
import ScheduleHistory from "./Screens/ScheduleHistory";
import { useSelector } from "react-redux";
import HelperRoute from "./HelperRoutes";
import NewLanding from "./Screens/NewLanding";
import Vault from "./Screens/Vault";
import Referral from "./Screens/Referral";
import Faq from "./Screens/Faq";
import Cookies from "./Screens/Cookies";

function App() {
  const [isConnected, setConnected] = useState(false);

  const { walletaddress } = useSelector((state) => state.wallet);
  console.log(
    walletaddress,
    walletaddress ? true : false,
    "walletaddresswalletaddress"
  );

  useEffect(() => {
    console.log("Is Connected Routed : ", isConnected);
    setConnected(walletaddress ? true : false);
  }, [walletaddress]);

  return (
    <>
      <HelperRoute></HelperRoute>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/:code" element={<Landing />} />
        {/* <Route path="/" element={<NewLanding />} /> */}

        <Route path="/plans" element={<Plans />} />
        <Route path="/faq" element={<Faq />} />
        {/* {isConnected ? (
          <> */}
        <Route path="/opportunities" element={<Opportunities />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/transactionHistory" element={<TransactionHistory />} />
        <Route path="/scheduleHistory" element={<ScheduleHistory />} />
        <Route path="/supportTicket" element={<SupportTicket />} />
        {/* </>
        ) : (
          <></>
        )} */}
        {/* <Route path="/supportTicket" element={<SupportTicket />} /> */}
        <Route path="/ticketManagement" element={<TicketManagement />} />
        <Route path="/termsOfServices" element={<TermsOfServices />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/vault" element={<Vault />} />
        <Route path="/referral" element={<Referral />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
      {/* </Provider> */}
    </>
  );
}

export default App;
